module.exports = " Your search history is empty!"


//////////////////
// WEBPACK FOOTER
// ./src/user-history/views/user-history-item-empty.html
// module id = 450
// module chunks = 1